<!--h1 mat-dialog-title>{{data.title}}</h1-->
<div mat-dialog-content>
  <p class="mat-dialog-title" >{{data.title}}</p>
  <button *ngFor="let i of data.items" (click)="onItemClick(i)"
    [style.margin-bottom]="'5px'">{{ i }}</button>
</div>
<!--div mat-dialog-actions>
  <button mat-button (click)="onCancelClick()">Cancel</button>
  <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
</div-->